export default "__VITE_ASSET__BMUOxV06__"